<template>
  <div>     
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
    @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <div class="trade-box">
      <div class="trade-bg"></div>
      <div class="trade-select-label-body">
        <div class="label-item label-box">
          <span>设备：</span>
          <ul class="label-select-ul">
            <li class="label-select-li" v-for="(item,index) in deviceList" :key="index" 
              :class="tradeBean.device === index?'label-select-active-li':''" 
              @click="selectTrade(1,index)">{{item.title}}</li>
          </ul>
        </div>
        <div class="label-item label-box">
          <span>类型：</span>
          <ul class="label-select-ul">
            <li class="label-two-select-li" v-for="(item,index) in typeList" :key="index"
             @click="selectTrade(2,item.id)" :class="tradeBean.type == item.id ? 'label-two-select-active-li':''">{{item.text}}</li>
          </ul>
        </div>
        <div class="label-item label-box">
          <span>字母：</span>
          <ul class="label-select-ul">
            <li class="label-two-select-li" v-for="(item,index) in letterList" :key="index" 
            @click="selectTrade(3,index)" :class="tradeBean.letter == index ? 'label-two-select-active-li':''">{{item.title}}</li>
          </ul>
        </div>
        <div class="label-item label-box" style="margin-top: 10px;">
          <span>搜索: </span>
          <div class="label-search">
            <input class="label-input" placeholder="请输入商品名和关键词" v-model="tradeBean.search"
            v-on:input="selectTrade(4)">
            <span class="label-button" @click="selectTrade(4)">搜索</span>
          </div>
          <span class="label-sole" @click="showInsertTrade"><i></i>角色出售</span>
        </div>
        <div class="select-box">
          <div class="select-left-box">
            <span class="select-body" @click="selectTrade(5)" style="margin-right: 20px;">
              默认排序
              <i :class="rankDirection ? '' : 'select-body-i'"></i>
            </span>
            <span class="select-body" @click="selectTrade(6)">
              价格
              <i :class="priceDirection ? '' : 'select-body-i'"></i>
            </span>
          </div>
          <div class="select-right-box">
            <span class="select-label">价格: </span>
            <span class="select-price" :class="tradeBean.label == index ? 'select-price-active' : ''" v-for="(item,index) in priceList" :key="index"
              @click="selectTrade(7,index);">{{item}}</span>
            <input class="select-price-input" v-model="tradeBean.min" style="margin: 0 10px;">
            <span>-</span>
            <input class="select-price-input" v-model="tradeBean.max" style="margin: 0 10px;">
            <span class="select-sure" @click="selectTrade(8)">确定</span>
          </div>
        </div>
      </div>
      <div class="trade-body">
        <div class="trade-item" v-for="(item,index) in tradeList" :key="index">
          <div class="trade-header">
            <img @click="enterOfficial(item.game_tag,item.game_device)" class="trade-img" :src="baseImageAddress+'type=small&game_tag='+item.game_tag">
            <i style="left: 1px;top: 1px;" class="icon-center" :class="item.game_device == 1 ? 'icon-web' : item.game_device == 2 ? 'icon-mobile' : 'icon-h5'"></i>
            <span class="trade-title">{{item.trade_game_name}}</span>
          </div>
          <img class="trade-preview" @click="showPicture(item.trade_preview)"  :src="baseAddress+item.trade_preview">
          <div class="trade-data">
            <h1 class="trade-name">{{item.trade_game_name}}-{{item.trade_game_area_name}}</h1>
            <p>充值金额:<span class="trade-span" style="color: #da4444;">{{item.trade_invest}}</span></p>
            <p>
              <span class="trade-summary-label">商品描述:</span>
              <span class="trade-summary">{{item.trade_selling}}</span></p>
          </div>
          <span class="trade-money">¥{{item.trade_sole}}</span>
          <div class="trade-buy" @click="enterTradeDetails(item.trade_id);">查看商品</div>
        </div>
      </div>
      <CommonPage v-show="showPageState" class="center-game-page" :current.sync='tradeBean.page' :page-size="tradeBean.row" :total="tradeTotal" show-total  show-elevator 
        @on-change="selectPage" prev-text="上一页" next-text="下一页"/>
    </div>
    <div class="trade-ad-box"></div>
    <Footer></Footer>
    <TradeInsert v-show="insertState" @quitClose="quitClose" @quitHandle="quitHandle"></TradeInsert>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
    @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
    @changeLoginState="changeLoginState"></SuspendMember>
    <div v-show="showPopState" class="pop-mask" @click="closePop"></div>
    <div v-show="showPopState" class="pop-trade-body">
      <div class="top"></div>
      <div class="body">
        <div class="header">
          <span class="title">交易预览图</span>
          <img class="close" src="../../assets/image/window_close_normal.png" alt="关闭" @click="closePop">
        </div>
        <img class="img" :src="tradeImg">
      </div>
    </div>
  </div>
</template>
<script>
import Footer from '../../components/common/Footer';
import Header from '../../components/common/Header';
import SuspendSide from '../../components/SuspendSide';
import SuspendMember from '../../components/SuspendMember';
import TradeInsert from '../trade/TradeInsert';
import CommonPage from '../../components/CommonPage';
export default {
  metaInfo(){
    return {
      title:"交易中心_"+this.$store.state.home.title,
      meta:[
        { name:'keywords', content:this.$store.state.home.keywords},
        { name:'description',content:this.$store.state.home.description}
      ]
    }
  },
  computed:{
    baseImageAddress(){
      return this.$store.state.constant.baseImageAddress;
    },
    baseAddress(){
      return this.$store.state.constant.baseAddress;
    },
    typeList(){
      return this.$store.state.trade.typeList;
    },
    tradeList:{
      get(){
        return this.$store.state.trade.tradeList;
      },
      set(value){
        this.$store.state.trade.tradeList = value;
      }
    },
    tradeTotal:{
      get(){
        return this.$store.state.trade.tradeTotal;
      },
      set(value){
        this.$store.state.trade.tradeTotal = value;
      }
    },
    showPageState:{
      get(){
        return this.$store.state.trade.showPageState;
      },
      set(value){
        this.$store.state.trade.showPageState = value;
      }
    },
    deviceList(){
      return this.$store.state.constant.deviceList;
    },
    letterList(){
      return this.$store.state.constant.letterList;
    }
  },
  asyncData({store,route}){
    return store.dispatch('initTrade',{store:store})
  },
  data(){
    return{
      priceList:[
        "全部","1-100","100-500","500-1000",
        "1000-3000","3000以上"
      ],
      insertState:false,
      rankDirection:false, //排序方向
      priceDirection:false, //价格方向
      tradeBean:{
        device:0, //游戏设备
        type:0, //游戏类型
        letter:0, //字母
        search:'', //搜索交易名称
        rank:0, //排序
        price:0, //价格排序
        label:0, //价格区间
        min:'', //最小价格
        max:'', //最大价格
        page:1, //页数
        row:10, //数量
      },
      tradeImg:"",
      showPopState:false,
      loginState:false,
      suspendState:false,
      suspendType:0
    }
  },
  components: {
    Header, Footer, SuspendSide,TradeInsert,SuspendMember, CommonPage
  },
  methods:{
    changeSuspendState(value){
      this.suspendState = value;
    },
    changeSuspendType(value){
      this.suspendType = value;
    },
    changeLoginState(value){
      this.loginState = value;
    },
    quitClose(value){
      this.insertState = value;
    },
    quitHandle(){
      this.insertState = false;
      this.queryAllTrade();
    },
    showInsertTrade(){
      if(this.loginState){
        this.insertState = true;
      }else{
        this.launchType = 1;
        this.enterLogin();
      }
    },
    enterLogin(){
      this.changeSuspendState(true);
      this.changeSuspendType(0);
    },
    closePop(){
      this.showPopState = false;
    },
    showPicture(value){
      this.showPopState = true;
      this.tradeImg = this.baseAddress + value;
    },
    enterOfficial(tag,type){
      if(type == 1){
        window.open('/webOfficial/'+tag,'_blank');
      }else{
        window.open("/mobileOfficial/"+tag,'_blank');
      }
    },
    enterTradeDetails(value){
      window.open(this.$router.resolve({name:'tradeDetails',query:{tid:value}}).href,"_blank");
    },
    //1:设备 2:类型 3:字母 4:价格 5:排序 6:价格
    selectTrade(type,value){
      if(type == 1){
        this.tradeBean.device = value;
      }else if(type == 2){
        this.tradeBean.type = value;
      }else if(type == 3){
        this.tradeBean.letter = value;
      }else if(type == 5){
        if(this.rankDirection){
          this.rankDirection = false;
          this.tradeBean.rank = 0; //从大到小
        }else{
          this.rankDirection = true;
          this.tradeBean.rank = 1; //从小到大
        }
      }else if(type == 6){
        if(this.priceDirection){
          this.priceDirection = false;
          this.tradeBean.price = 0; //从大到小
        }else{
          this.priceDirection = true;
          this.tradeBean.price = 1; //从小到大
        }
      }else if(type == 7){
        this.tradeBean.label = value;
        this.tradeBean.max = undefined;
        this.tradeBean.min = undefined;
      }else if(type == 8){
        this.tradeBean.label = 0;
      }
      this.queryAllTrade();
    },
    selectPage(value){
      this.tradeBean.page = value;
      this.queryAllTrade();
    },
    queryAllTrade(){
      this.$http.get(`query_all_trade`,{
        params:this.tradeBean
      }).then(res=>{
        if (res.data.code == 2000) {
          this.tradeList = res.data.data;
          this.tradeTotal = res.data.total;
          if(this.tradeTotal > 10){
            this.showPageState = true;
          }else{
            this.showPageState = false;
          }
        }else{
          this.tradeTotal = 0;
          this.tradeList = [];
          this.showPageState = false;
        }
      })
    },
  },
  watch:{
    loginState:function(value){
      if(value){
        if(this.launchType == 1){
          this.insertState = true;
        }
      }
    },
  } 
}
</script>
<style src="@/assets/css/trade/trade.css" scoped></style>
<style>
  .center-game-page .ivu-page-prev,.center-game-page .ivu-page-next{
    background: #ffffff;
  }
</style>